import { Component, OnInit } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-exhibitor-modified',
  templateUrl: './modal-exhibitor-modified.component.html',
  styleUrls: ['./modal-exhibitor-modified.component.css']
})
export class ModalExhibitorModifiedComponent implements OnInit {


  oldEmail: string = '';
  affectedExhibitors: number = 0;

  constructor(public catalogueService: CatalogueService, private ngbActiveModal: NgbActiveModal) { }

  close() {
    this.ngbActiveModal.close();
  }

  setOption(option) {
    this.ngbActiveModal.close(option);
  }

  ngOnInit() {
  }

}
